import { Link } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';

const TIER_COPY = {
  pro: { label: 'Pro Feature', cta: 'Start 14-Day Free Trial (£4.99/mo)', price: '£4.99/month' },
  pro_plus: { label: 'Pro+ Feature', cta: 'Start 14-Day Free Trial (£9.99/mo)', price: '£9.99/month' },
};

export default function ProUpsell({ feature = 'this feature', testIdSuffix = 'feature', tier = 'pro_plus' }) {
  const t = TIER_COPY[tier] || TIER_COPY.pro_plus;
  return (
    <div className="max-w-2xl mx-auto px-4 py-12">
      <div className="tm-card tm-card-dark p-8 sm:p-10 text-center border border-slate-200 shadow-md">
        <div className="inline-flex items-center justify-center w-14 h-14 border border-brand" style={{ background: 'rgb(var(--tm-brand-rgb) / 0.1)' }}>
          <Lock size={28} className="text-brand"/>
        </div>
        <p className="text-xs uppercase tracking-widest text-brand mt-4 font-semibold">{t.label}</p>
        <h1 className="font-display font-semibold text-3xl sm:text-4xl uppercase tracking-tight mt-2">
          {feature} is a <span className="text-brand">{tier === 'pro_plus' ? 'Pro+' : 'Pro'}</span> feature
        </h1>
        <p className="text-slate-300 mt-3 max-w-md mx-auto">Try free for 14 days, then {t.price}. Cancel any time.</p>
        <div className="mt-6 flex flex-wrap gap-3 justify-center">
          <Link to="/pricing" data-testid={`pro-upsell-${testIdSuffix}`} className="tm-btn">
            <Sparkles size={16}/> {t.cta}
          </Link>
          <Link
            to="/trades"
            className="tm-btn"
            style={{ background: '#fff', color: '#0F172A' }}
          >
            Browse free calculators
          </Link>
        </div>
      </div>
    </div>
  );
}
